import type { RefundVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveRefundList = createApiThunk<RefundVM[], void>(
  "refunds/retrieveRefundList",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.listRefunds();
  },
);
